<template>
  <div v-if="isInviter" class="flex flex-col gap-2">
    <label for="gameMode">Type of game:</label>
    <select v-model="gameMode" class="form-control" name="gameMode" id="gameMode">
      <option value="Cricket" selected>Cricket</option>
    </select>
    <div class="flex flex-col gap-2" v-if="gameMode === 'Cricket'">
      <label for="gameMode">Play till number:</label>
      <select v-model="cricketTill" class="form-control" name="gameMode" id="gameMode">
        <option value="15" selected>15</option>
        <option value="14">14</option>
        <option value="13">13</option>
        <option value="12">12</option>
        <option value="11">11</option>
        <option value="10">10</option>
      </select>
    </div> 

    <label for="gameMode">Sets to win:</label>
    <input type="number" v-model="setsToWin" class="form-control" min="1" max="10">

    <div class="flex flex-col gap-2" v-if="againstBot">
      <label for="botDifficulty">Bot difficulty:</label>
      <select v-model="botDifficulty" class="form-control" name="botDifficulty" id="botDifficulty">
        <option value="easy" selected>Easy</option>
        <option value="medium">Medium</option>
        <option value="hard">Hard</option>
        <option value="pro">Pro</option>
      </select>
    </div>

    <div class="flex justify-center gap-2">
      <button @click="startGame" class="btn btn-success w-full">
        Start the Game
      </button>
    </div>
  </div>
  <div v-else class="flex flex-col gap-4 items-center text-center">
    <LoaderAnimation/>
    <p>Please wait...<br/>
      The other player is creating a Game.</p>
  </div>
</template>

<script>
import LoaderAnimation from "@/components/LoaderAnimation.vue";

export default {
  name: "GameMode",
  components: {
    LoaderAnimation
  },
  props: {
    socket: Object,
    gamePlayers: Object,
    currentUserId: String
  },
  data() {
    return {
      isInviter: this.gamePlayers.find(p => p.id === this.currentUserId).inviter,
      gameMode: 'Cricket',
      cricketTill: '15',
      setsToWin: 3,
      botDifficulty: 'easy',
    };
  },
  computed: {
    againstBot() {
      return this.gamePlayers.some(p => p.bot);
    }
  },
  methods: {
    startGame() {
      if (this.isInviter) {
        this.socket.emit('startGame', { gamePlayers: this.gamePlayers, gameMode: this.gameMode, cricketTill: this.cricketTill, setsToWin: this.setsToWin, botDifficulty: this.botDifficulty });
      }
    },
  },
};
</script>
